import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 scroll-mt-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">实时动态</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新更新</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">实时追踪漫画更新动态，热门连载第一时间送达</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 before:absolute before:left-3 before:top-2 before:bottom-2 before:w-0.5 before:bg-background-300">
            {updates.map((item, index) => (
              <div key={item.id} className={`relative pb-6 ${index === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute left-[-1.25rem] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap font-mono">{item.date}</span>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 flex-wrap mb-1">
                      <h3 className="font-heading font-bold text-sm text-foreground-900">{item.title}</h3>
                      <span className="px-1.5 py-0.5 text-[10px] font-medium bg-primary-100 text-primary-700 rounded">{item.tag}</span>
                    </div>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}